module.exports = "\r\n    <router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Websites/Planeto/PlanetoAngular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main